import ArrowLeft from "../common/ArrowLeft";
import ArrowRight from "../common/ArrowRight";
import ExitButton from "../common/ExitButton";

// Component for handling navigation during an active tour

function TourDisplay({ currentLocation, activeIndex, total, onClose, onPrev, onNext, isContentCollapsed }) {
  
  if (!currentLocation) return null;

  return (
    <div
      className="tour-display-container"
      style={{
        left: isContentCollapsed ? "50%" : "25%",
        transform: "translateX(-50%)",
      }}
    >
      <div className="tour-display-header">
        <p className="tour-display-title"><strong>{currentLocation.name}</strong></p>
      </div>

      <ExitButton
        onClick={onClose}
        style={{
          position: "absolute",
          top: "6px",
          right: "6px",
          display: "inline-flex",
        }}
      />

      <div>
        <button
          className="tour-display-button"
          disabled={activeIndex === 0}
          onClick={onPrev}
        >
          <ArrowLeft />
        </button>
        <span style={{ margin: "0 8px" }}>
          {activeIndex + 1}/{total}
        </span>
        <button
          className="tour-display-button"
          disabled={activeIndex === total - 1}
          onClick={onNext}
        >
          <ArrowRight />
        </button>
      </div>
    </div>
  );
}

export default TourDisplay;